import TagSelect from './tag-select.vue';
import TagSelectOption from './tag-select-option.vue';

TagSelect.Option = TagSelectOption;

export default TagSelect;



// WEBPACK FOOTER //
// ./src/components/tag-select/index.js